<template>
    <div id="container">
        <vue-progress-bar></vue-progress-bar>
        <Sidebar></Sidebar>
        <div id="page-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar.vue";
import { SnotifyPosition } from "vue-snotify";
export default {
    name: "Home",
    components: {
        Sidebar,
    },
    sockets: {
        execute: function (data) {
            switch (data.type) {
                case "patients":
                    this.$store.dispatch("fillPatients");
                    break;
                case "khd":
                    this.$store.dispatch("fillKHD");
                    break;
            }
        },
        notify: function (data) {
            switch (data.type) {
                case "new-birth":
                    this.$snotify.info(
                        "Yeni bebek kaydı yapıldı (" + data.isim + ")",
                        {
                            position: SnotifyPosition.rightTop,
                        }
                    );
                    break;

                case "new-yatis":
                    this.$snotify.info(
                        data.isim +
                            " (" +
                            data.detail +
                            ")" +
                            " yatışı yapıldı.",
                        {
                            position: SnotifyPosition.rightTop,
                        }
                    );
                    this.$store.dispatch("fillPatients");
                    break;
            }
        },
    },
};
</script>

<style lang="scss">
// Yeni Yatış
.yatis-content {
    display: flex;
    align-items: flex-start;
    .wizard {
        flex: 1 1 45%;
    }
    .p-not {
        flex: 1 1 55%;
    }
}

.wizard {
    margin: 10px;
    background-color: white;
    box-sizing: border-box;
    border: 1px solid $alphaDivider;
    display: flex;
    flex-direction: column;
}
.wizard-bar {
    flex: 0 0 auto;
    background-color: $gray-300;
    border-bottom: 1px solid $gray-400;
    background-image: url("../assets/panel_bg.png"),
        linear-gradient(to top left, white, $gray-300);
    background-repeat: repeat;
    padding: 5px 0;
    .page {
        margin: 5px 20px;
        padding: 5px 0;
        color: $blue;
        font-weight: 700;
        .no {
            font-size: 20px;
            display: block;
            padding: 2px 0;
        }
        .head {
            font-size: 15px;
            display: block;
        }
    }
}

.wizard-content {
    flex: 1 1 auto;
    position: relative;
    min-height: 660px;
    background-color: $gray-100;
    padding-bottom: 51px;
    .prev-warning {
        color: $blue;
        font-weight: 500;
        display: block;
        margin-left: 40%;
        height: 40px;
        line-height: 40px;
    }
    .wizard-buttons {
        position: absolute;
        bottom: 0;
        padding: 10px 5px;
        border-top: 1px solid $gray-400;
        background-color: white;
        background-image: url("../assets/panel_bg.png"),
            linear-gradient(to bottom right, white, $gray-300);
        background-repeat: repeat;
        left: 0;
        right: 0;
    }
}
.p-form {
    padding: 10px;
    h4 {
        margin: 6px;
        padding: 6px 0;
        border-bottom: 0 solid $gray-200;
        color: rgb(99, 97, 97);
        font-size: 15px;
    }
}
.p-not {
    //background-color: white;
    display: block;
    min-height: 700px;
    margin: 10px;
    flex: 1 1 auto;
    //box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    //    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    padding: 10px;
    color: black;
    font-size: 12px;
    line-height: 19px;
    p {
        margin-bottom: 10px;
        white-space: pre-line;
    }
    ul {
        list-style-type: none;
        padding-left: 15px;
        margin-bottom: 10px;
    }
    ul li::before {
        content: "-";
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }
}

// Birthlist
.warnings {
    display: flex;
    .box {
        flex: 1 1 50%;
        margin: 15px;
        border-radius: 5px;
        color: white;
        font-weight: 500;
        display: flex;
        .title {
            flex: 1 1 auto;
            line-height: 30px;
            padding: 5px;
        }
        .icon {
            flex: 0 0 auto;
            padding: 5px;
            svg {
                height: 30px;
                width: 30px;
            }
        }
    }
}

.birth-content {
    border-bottom: 1px solid $gray-400;
}

.birth-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    #printBirthList,
    #printVizitList {
        flex: 1 0 auto;
        table {
            border-spacing: 0;
            width: 100%;
            border-collapse: collapse;
            border-radius: 5px;
            table-layout: auto;
            tr td {
                cursor: pointer;
                span.detail {
                    display: block;
                }
                span.saat {
                    font-weight: bold;
                    color: red;
                }
                word-wrap: break-word;
                white-space: pre-line;
            }
            tr:hover td {
                background-color: transparentize($primary, 0.8);
            }
            tr.empty:hover td {
                cursor: inherit;
                background-color: inherit;
            }
            th,
            td {
                text-align: left;
                padding: 5px;
                color: #000;
            }
            th {
                background-color: $gray-300;
                border-top: 1px solid $gray-400;
                border-bottom: 1px solid $gray-400;
            }
            tr:nth-child(even) {
                background: $gray-100;
            }
            tr:nth-child(odd) {
                background: white;
            }
        }
        .p-header {
            border: 0;
            background-color: white;
        }
        .c-center {
            text-align: center;
        }
        .c-top {
            vertical-align: top;
        }
        .w-4 {
            width: 4%;
        }
        .w-8 {
            width: 8%;
        }
        .w-12 {
            width: 12%;
        }
        h3 {
            text-align: center;
            padding: 10px 0;
        }
    }
}

@media (max-width: 1280px) {
    .birth-list {
        overflow-x: auto;
    }
    .warnings {
        width: 100%;
        flex-direction: column;
        ul {
            width: 100%;
            margin: 4px 0;
            flex: 1 1 100% !important;
        }
    }
}

// Devir

.y-devir.modal {
    padding: 0;
    line-height: inherit;
    p,
    ul {
        line-height: 19px;
    }
}
.p-devir {
    padding-top: 40px;
    width: 100%;
    .page {
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
        width: 80%;
        margin: 0 auto;
        .b-tarih {
            flex: 1 1 100%;
            text-align: center;
            margin-bottom: 20px;
            font-weight: 700;
            font-size: 19px;
        }
        p.servis {
            margin-bottom: 10px;
            border-bottom: 1px solid #000;
            color: #000;
        }
        div.hasta {
            background-color: white;
            margin: 10px;
            border: 1px solid $alphaDivider;
            flex: 1 1 100%;
            border-radius: 5px;
            white-space: pre-line;
            margin-bottom: 10px;
            line-height: 19px;
            color: #000;
            p {
                margin: 0.5em 0.5em;
            }
            .top-devir {
                display: flex;
                padding: 5px 10px;
                font-weight: 700;
                border-bottom: 1px solid $gray-300;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                background-color: $gray-200;
                div {
                    flex: 0 0 auto;
                    span {
                        font-weight: 400;
                        display: block;
                        width: 100%;
                    }
                    &.name {
                        flex-grow: 1;
                    }
                    &.no {
                        font-size: 18px;
                        line-height: 38px;
                        padding-right: 8px;
                    }
                    &.oda {
                        font-size: 14px;
                        line-height: 38px;
                    }
                }
            }
            ul {
                list-style-type: square;
                padding-left: 25px;
                margin-bottom: 10px;
            }
            &:hover {
                background-color: $gray-300;
                cursor: pointer;
            }
        }
    }
}
@media (max-width: 1280px) {
    .p-devir > .page {
        width: 100% !important;
    }
    .p-devir {
        .oda {
            word-wrap: break-word;
            max-width: 70px;
            line-height: 14px !important;
            font-size: 12px !important;
        }
    }
}

// Servis ve Yenidogan
.servis-content {
    padding: 68px 280px 0 0 !important;
    display: flex;
    flex-wrap: wrap;
}

.no-patient {
    padding-right: 280px;
}

.patient-profile {
    flex: 1 1 100%;
    margin: 15px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .patient-header {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        background-color: white;
        border-radius: 10px;
        position: relative;
        margin-top: 20px;
        width: 100%;
        border: 1px solid $gray-300;
        div.sex {
            position: absolute;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            top: -10px;
            border-radius: 5px;
            width: 50px;
            height: 50px;
            span {
                border-radius: 25px;
                display: block;
            }
            svg {
                padding: 10px;
                width: 50px;
                height: 50px;
                color: white;
            }
        }
        .name {
            margin-top: 25px;
            margin-bottom: 5px;
            width: 100%;
            text-align: center;
            font-size: 17px;
            font-weight: 700;
            line-height: 20px;
        }
        .age {
            margin-bottom: 5px;
            width: 100%;
            text-align: center;
            font-size: 14px;
            line-height: 20px;
            color: $gray-600;
        }
        .btn-group {
            padding: 2px;
            border-bottom: 1px solid $gray-200;
            background-color: $gray-100;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
        ul.bulgular {
            list-style-type: none;
            display: flex;
            margin-bottom: 5px;
            li.info {
                flex: 1 1 33.3%;
                height: 80px;
                border-right: 1px solid $gray-200;
                text-align: center;
                vertical-align: top;
                background-color: white;
                margin-top: 10px;
                span.title {
                    font-size: 14px;
                    display: block;
                    padding: 5px;
                    color: $green;
                }
                span.value {
                    font-size: 18px;
                    font-weight: 500;
                    display: block;
                    padding: 5px;
                }
                span.persantil {
                    font-size: 13px;
                    color: $gray-600;
                    display: block;
                    padding-bottom: 3px;
                }
                &:last-child {
                    border-right: 0;
                }
            }
        }
    }
    .header {
        position: relative;
        width: 100%;
        flex: 1 1 100%;
        div.sex {
            position: absolute;
            margin: 0;
            top: 10px;
            left: 5px;
            border-radius: 5px;
            right: 0;
            width: 35px;
            height: 35px;
            span {
                border-radius: 17px;
                display: block;
            }
            svg {
                color: white;
                padding: 5px;
                width: 35px;
                height: 35px;
            }
        }
        h3 {
            padding: 10px 10px 5px 50px;
            text-align: left;
        }
        div.yas {
            color: $gray-700;
            display: block;
            padding: 0 5px 10px 50px;
            font-size: 14px;
        }
        .btn-group {
            .btn {
                display: inline-block;
                margin: 4px 0;
                padding: 5px !important;
            }
        }
    }

    div.details {
        display: block;
        width: 100%;
        margin-top: 15px;
        div.tanilar {
            margin-top: 5px;
            font-weight: 700;
            background-color: white;
            line-height: 20px;
            width: 100%;
            display: inline-block;
            position: relative;
            border-radius: 10px;
            font-size: 14px;
            height: 70px;
            vertical-align: top;
            background-color: $gray-100;
            border-top: 1px solid $gray-200;
            div.gun {
                background-color: $gray-100;
                color: $blue;
                height: calc(100% - 10px);
                width: 60px;
                margin: 5px;
                padding: 12px 0;
                line-height: 17px;
                text-align: center;
                display: block;
                position: absolute;
                font-size: 17px;
                font-weight: 500;
                border-radius: 5px;
                left: 0;
                top: 0;
            }
            span {
                display: block;
                padding: 6px 10px 6px 70px;
                width: 100%;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }

        ul.boy-bas {
            list-style-type: none;
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            li.info {
                flex: 1 1 100%;
                margin: 0 5px;
                border-radius: 5px;
                border: 1px solid $gray-300;
                background-color: white;
                span.title {
                    font-size: 13px;
                    display: inline-block;
                    padding: 5px;
                    color: $blue;
                    width: 100px;
                    border-bottom-left-radius: 5px;
                    border-top-left-radius: 5px;
                    background-color: $gray-200;
                }
                span.value {
                    font-size: 13px;
                    display: inline-block;
                    padding: 5px;
                }
            }
        }
    }
}

.patient-col {
    display: block;
    width: 100%;
    position: relative;
}
.y-not-data {
    margin-top: 20px;
    margin-bottom: 10px;
    background-color: white;
    border-left: 1px solid $gray-300;
    border-right: 1px solid $gray-300;
    border-bottom: 1px solid $gray-300;
    .info-header {
        background-color: $gray-200;
        border-top: 1px solid $gray-300;
        border-bottom: 1px solid $gray-300;
        height: 26px;
        a.btn {
            display: block;
            float: right;
            margin: 0;
        }
        span.title {
            display: inline-block;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
        }
    }
    .y-not {
        padding: 10px;
        color: black;
        font-size: 12px;
        line-height: 19px;
        .invisible {
            display: none;
        }
        p {
            margin-bottom: 10px;
            white-space: pre-line;
        }
        ul {
            list-style-type: none;
            padding-left: 15px;
            margin-bottom: 10px;
        }
        ul li::before {
            content: "-";
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
        }
    }
}

.snap-warning {
    display: flex;
    border: 1px solid $red;
    background-color: transparentize($red, 0.9);
    flex-direction: column;
    border-radius: 5px;
    width: 100%;
    .box {
        flex: 1 1 100%;

        margin: 10px;
        border-radius: 5px;
        color: white;
        font-weight: 500;
        display: flex;
        .title {
            flex: 1 1 auto;
            line-height: 20px;
            padding: 5px;
        }
        .icon {
            flex: 0 0 auto;
            padding: 5px;
            svg {
                height: 20px;
                width: 20px;
            }
        }
    }
    .form {
        padding: 5px;
        flex: 1 1 auto;
        button {
            margin: 5px;
        }
    }
}

.y-readonly-data {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    ul.patient-infos {
        list-style-type: none;
        flex-direction: column;
        li.info {
            display: block;
            margin: 0;
            .info-header {
                border-bottom: 1px solid $gray-300;
                text-align: right;
            }
            span.title {
                display: inline-block;
                font-size: 13px;
                padding: 5px;
                color: $blue;
                font-weight: 500;
            }
            span.status {
                display: inline-block;
                font-size: 12px;
                padding: 5px;
            }
            span.value {
                display: block;
                font-size: 12px;
                padding: 5px;
                white-space: pre-line;
                line-height: 19px;
            }
        }
    }

    div.hikaye {
        padding: 5px;
        font-size: 12px;
        p {
            margin-bottom: 10px;
            display: flex;
            line-height: 19px;
            white-space: pre-line;
        }
        ul {
            list-style-type: circle;
            list-style-position: outside;
            padding-left: 15px;
            margin-bottom: 10px;
            line-height: 19px;
        }
    }
}

.y-special-data {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    margin-top: 15px;
    ul.patient-infos {
        list-style-type: none;
        flex-direction: column;
        li.info {
            display: block;
            margin-bottom: 10px;
            background-color: white;
            border-left: 1px solid $gray-300;
            border-right: 1px solid $gray-300;
            .info-header {
                background-color: $gray-200;
                border-top: 1px solid $gray-300;
                border-bottom: 1px solid $gray-300;
                a.btn {
                    display: block;
                    float: right;
                    margin: 0;
                }
            }
            span.title {
                display: inline-block;
                font-size: 13px;
                padding: 5px;
                color: $blue;
                font-weight: 500;
            }

            span.value {
                display: block;
                font-size: 12px;
                padding: 5px;
                white-space: pre-line;
                line-height: 19px;
                border-bottom: 1px solid $gray-300;
            }
            .small-empty {
                border-bottom: 1px solid $gray-300;
            }
            div.edit-form {
                background-color: $gray-100;
                padding: 4px;
                border-bottom: 1px solid $gray-300;
                .btn-bar {
                    text-align: right;
                    padding: 4px 0;
                }
            }
        }
    }
}
.y-tedavi-plan {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    flex-grow: 1;
    .col {
        flex: 1 1 50%;
    }
    ul.oneriler {
        width: 100%;
        flex: 1 1 auto;
        list-style-type: none;
        .info-header {
            background-color: $gray-200;
            border-bottom: 1px solid $gray-300;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
        }
        li a {
            padding: 6px 4px;
            font-size: 13px;
            span {
                margin: 0 4px;
                font-weight: 500;
            }
        }
    }
    ul.ilaclar {
        width: 100%;
        flex: 1 1 auto;
        list-style-type: none;
        margin-top: -5px;
        .info-header {
            background-color: $gray-200;
            border-bottom: 1px solid $gray-300;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
        }
        li {
            padding: 0 4px;
            width: 100%;
            a {
                display: block;
                padding: 8px 0;
                font-size: 13px;
                span {
                    margin: 0 4px;
                    font-weight: 500;
                }
                svg {
                    float: right;
                }
            }
            &:nth-child(even) {
                background-color: $gray-100;
            }
            &:nth-child(odd) {
                background-color: white;
            }
        }
    }
    div.ilac-detail {
        display: flex;
        flex-direction: column;
        .ilac-header {
            margin-top: -5px;
            background-color: $gray-200;
            flex: 1 1 100%;
            font-weight: 700;
            a {
                padding: 10px;
            }
        }
        .content {
            flex: 1 1 auto;
            padding: 7px;
            p {
                padding: 8px 0;
            }
            table {
                width: 100%;
                border: 1px solid $gray-300;
                border-collapse: collapse;
                border-radius: 5px;
                text-align: center;
                thead {
                    background-color: $orange;
                    th {
                        padding: 5px;
                    }
                }
                tbody {
                    tr {
                        border-top: 1px solid $gray-200;
                    }
                    td {
                        padding: 5px;
                    }
                }
            }
        }
    }
    ul.sablon {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        .info-header {
            background-color: $gray-200;
            border-bottom: 1px solid $gray-300;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
            margin-bottom: 3px;
        }
        li.info {
            flex: 1 0 auto;
            margin: 3px 5px;
            text-align: left;
            span.title {
                display: inline-block;
                width: 45%;
                font-size: 13px;
                padding: 6px;
                color: $blue;
            }
            span.value {
                display: inline-block;
                font-size: 13px;
                padding: 6px;
                font-weight: 500;
                width: 55%;
            }
        }
    }

    ul.drugs {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        .info-header {
            background-color: $gray-200;
            border-bottom: 1px solid $gray-300;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
        }
        .search-box {
            padding: 8px;
            input {
                width: 100%;
            }
        }
        li.drug {
            flex: 1 0 auto;
            border-bottom: 1px solid $gray-200;
            text-align: left;
            background-color: white;
            a {
                display: block;
                width: 100%;
                font-size: 13px;
                padding: 8px;
                color: $gray-700;
                &:hover {
                    background-color: $gray-200;
                    color: black;
                }
            }
        }
    }
}

.fslightbox-container {
    left: 230px !important;
    right: 0 !important;
    width: calc(100% - 230px) !important;
}
@media (max-width: 1280px) {
    .fslightbox-container {
        left: 0 !important;
        top: 45px !important;
        width: 100% !important;
    }
}

div.fototerapi {
    display: block;
    //border: 1px solid $orange;
    background-color: white;
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    div.content {
        flex: 1 1 100%;
        display: flex;
        flex-direction: row;
        position: relative;
        cursor: pointer;
        height: 76px;
        &:hover {
            background-color: $gray-100;
        }
        div.name {
            font-size: 14px;
            font-weight: 700;
            position: absolute;
            top: 5px;
            left: 5px;
            span {
                color: $cyan;
            }
        }
        div.details {
            flex: 1 1 auto;
            padding: 5px;
            margin-top: 20px;
            line-height: 22px;
            font-size: 11px;
            font-weight: 500;
            svg {
                color: $gray-600;
            }
        }
        div.now {
            flex: 0 0 80px;
            line-height: 74px;
            font-size: 14px;
            margin-right: 80px;
        }
    }
    div.f-widget {
        position: absolute;
        top: 0;
        right: 0;
        width: 80px;
        overflow: hidden;
        flex-direction: column;
        &.exchange {
            div.value {
                background-color: lighten($red, 10);
            }
            div.sinir {
                background-color: $red;
            }
        }
        &.high {
            div.value {
                background-color: lighten($orange-dark, 10);
            }
            div.sinir {
                background-color: $orange-dark;
            }
        }
        &.medium {
            div.value {
                background-color: lighten($orange, 10);
            }
            div.sinir {
                background-color: $orange;
            }
        }
        &.low {
            div.value {
                background-color: lighten($orange-light, 10);
            }
            div.sinir {
                background-color: $orange-light;
            }
        }
        div.value {
            width: 100%;
            font-size: 11px;
            padding: 3px;
            font-weight: 500;
            text-align: center;
            line-height: 18px;
        }
        div.sinir {
            flex: 1 1 auto;
            font-weight: 700;
            font-size: 20px;
            padding: 8px;
            line-height: 18px;
            text-align: center;
            &:after {
                text-align: center;
                content: "mg/dL";
                display: block;
                font-size: 10px;
                font-weight: 500;
            }
        }
    }
    div.extra {
        flex: 1 1 100%;
        display: flex;
        flex-direction: row;
        max-height: 0px;
        overflow: hidden;
        background-color: $gray-100;
        transition: all 500ms ease;
        &.expand {
            max-height: 80px;
        }
        div.f-widget {
            position: relative;
            border-radius: 5px;
            margin: 5px;
            flex: 1 1 auto;
            div.value,
            div.sinir {
                background-color: $gray-100 !important;
            }
            div.value {
                color: black !important;
            }

            &.exchange {
                color: $red;
            }
            &.high,
            &.medium,
            &.low {
                color: $orange-dark;
            }
        }
    }
}

.y-editingtable {
    display: flex;
    flex-direction: column;
    position: relative;
    min-height: 300px;
    .topbar {
        background-color: $background;
        border-bottom: 1px solid $divider;
        justify-content: flex-end;
        display: flex;
        padding: 5px 0;
    }
    table {
        width: 100%;
        flex: 1 1 auto;
        border-collapse: collapse;
        border-radius: 5px;
        tr td {
            cursor: pointer;
        }
        tr:hover td {
            background-color: transparentize($primary, 0.8);
        }
        tr.empty th {
            height: 84px;
            background-color: lighten($orange, 15) !important;
        }
        th,
        td {
            text-align: left;
            padding: 5px;
        }
        th {
            background-color: darken($background, 10);
        }
        tr:nth-child(odd) {
            background: $background;
        }
        tr:nth-child(even) {
            background: white;
        }
        .w-50 {
            width: 50%;
        }
        .w-35 {
            width: 35%;
        }
        .w-10 {
            width: 10%;
        }
        .w-5 {
            width: 5%;
        }
    }
}

.y-milestones {
    margin-bottom: auto;
    div.devir-box {
        line-height: 19px;
        margin: 8px;
        input,
        textarea {
            background-color: $input;
        }
        background-color: $input;
        textarea {
            border: 0;
        }
        border: 1px solid $gray-300;
        p {
            background-color: $gray-300;
            border-bottom: 1px solid $gray-400;
            padding: 3px 5px;
            margin-bottom: 0;
        }
        div {
            padding: 5px 5px 0 5px;
        }
    }
}

.rop-list {
    padding: 50px 0 0 0;
    width: 100%;
    margin: 0 auto;
    background-color: lighten($blue, 30);
    div.title {
        padding: 0 15px;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        margin-bottom: 10px;
    }
    ul.list {
        list-style-type: none;
        li {
            padding: 0 15px;
            line-height: 24px;
            border-top: 1px solid $gray-100;
            span {
                display: inline-block;
            }
            span.name {
                min-width: 200px;
                font-weight: 700;
            }
            span.date {
                text-align: center;
                min-width: 110px;
            }
            span.from {
                font-weight: 700;
            }
        }
    }
}

.y-devir {
    &.boxed > div.devir-box,
    div.tedaviler {
        border-right: 1px solid $gray-300 !important;
        border-left: 1px solid $gray-300 !important;
    }
    div.content {
        padding: 7px 7px 0 7px;
        p {
            margin-bottom: 10px;
            input {
                width: 100%;
            }
        }
    }
    .rop-alert {
        div.title {
            width: 20%;
            display: inline-block;
            background-color: $red;
            line-height: 30px;
            font-weight: 700;
            font-size: 16px;
            vertical-align: middle;
        }
        div.detail {
            display: inline-block;
            width: 80%;
            background-color: lighten($red, 10);
            line-height: 30px;
        }
        color: white;
        text-align: center;
    }
    .devir-bar {
        padding: 7px;
        span.details {
            padding: 4px 0;
            display: block;
        }
        select {
            border-radius: 5px;
            margin: 0 2px;
            padding: 3px;
            background-color: $input;
        }
    }
    .toggle-group {
        &.rbtn {
            background: transparent !important;
            padding: 5px;
            border: 0 !important;
            label {
                flex: 0 0 calc(25% - 4px);
                margin: 0 2px;
                border-radius: 10px;
                span {
                    padding: 8px 0;
                    background-color: $gray-100;
                    border-radius: 10px;
                }
                border: 1px solid $gray-300;
                &:hover span {
                    background-color: $gray-200;
                    border-radius: 10px;
                }
            }
            margin-bottom: 5px;
        }
    }
    color: black;
    font-size: 13px;
    line-height: 19px;
    div.devir-box {
        background-color: $input;
        textarea {
            border: 0;
        }
        border-bottom: 1px solid $gray-300;
        p {
            background-color: $gray-300;
            border-bottom: 1px solid $gray-400;
            padding: 3px 5px;
            margin-bottom: 0;
        }
        div {
            padding: 5px 5px 0 5px;
        }
    }
    div.tedaviler {
        display: block;
        border-bottom: 1px solid $gray-300;
        background-color: $gray-100;
        .info-header {
            background-color: $gray-300;
            border-bottom: 1px solid $gray-400;
        }
        span.title {
            display: inline-block;
            font-size: 13px;
            padding: 3px 5px;
            width: 100px;
            font-weight: 700;
        }
        a.btn {
            display: inline-block;
            padding: 3px 5px;
        }
        ul {
            list-style-type: circle;
            list-style-position: inside;
            min-height: 102px;
            li {
                padding: 3px 6px;
                border-bottom: 1px solid $gray-300;
                &:hover {
                    cursor: pointer;
                    background-color: transparentize($primary, 0.8) !important;
                }
                &:last-child {
                    border-bottom: 0;
                }
            }
        }
    }
    .takip-input {
        width: 130px;
        border-radius: 5px;
    }
    .oda-input {
        width: 100px;
        border-radius: 5px;
    }
    input,
    textarea {
        background-color: $input;
    }
    .y-editingtable {
        min-height: 50px;
        margin-bottom: 5px;
        .topbar {
            background-color: transparent;
        }
    }
}

.y-progress {
    padding: 5px 10px;
    color: black;
    font-size: 12px;
    line-height: 19px;
    min-height: 300px;
    .small-empty {
        padding: 120px 0;
        span {
            padding: 0;
        }
    }
    ul {
        list-style-type: square;
        padding-left: 15px;
        margin-bottom: 10px;
    }
    p {
        padding: 5px;
        display: flex;
        white-space: pre-line;
        line-height: 21px;
        .key {
            font-weight: 700;
            flex: 0 0 50px;
        }
        .value {
            font-weight: 500;
            flex: 1 1 auto;
        }
    }
    .written {
        text-align: left;
        border-bottom: 1px solid $gray-200;
        padding: 10px 4px 4px 4px;
        font-weight: 500;
        margin-top: 10px;
    }
    .seyir-area {
        background-color: $input;
    }
}

.y-ozet {
    color: black;
    font-size: 12px;
    line-height: 19px;
    p {
        margin-bottom: 10px;
        .key {
            font-weight: 700;
            flex: 0 0 140px;
            display: block;
            padding: 0 5px;
            background-color: $gray-200;
            line-height: 35px;
            a {
                padding: 0;
                margin: 0 8px;
            }
        }
        .value {
            white-space: pre-line;
            flex: 1 1 auto;
            display: block;
            padding: 5px;
        }
        .small-empty {
            display: block;
        }
        .progress {
            display: block;
            margin-bottom: 10px;
        }
    }
}

.y-page {
    display: flex;
    .page-back {
        flex: 1 1 75%;
        background-color: #e6e6e6;
        line-height: 8px;
        padding: 50px 0;
        .page {
            margin: 0 auto;
            border: 1px solid #c6c6c6;
            background-color: white;
            width: 10.5cm;
            height: 14.35cm;
            padding: 0 0.75cm;
            font-size: 6px;
            overflow: hidden;
            color: black;
            div.progress {
                position: relative;
                input[type="checkbox"] {
                    position: absolute;
                    left: -15px;
                    width: initial;
                    height: initial;
                    visibility: visible;
                    clip: initial;
                    pointer-events: initial;
                }
                overflow: visible;
                white-space: pre-line;
                padding: 15px 0 0;
                display: flex;
                .left {
                    width: 50px;
                }
                .right {
                    flex: 1;
                }
                &.hidden {
                    color: transparent;
                }
            }
        }
    }
    .list {
        flex: 1 1 25%;
        padding: 10px 0;
        border-left: 1px solid #c6c6c6;
        .toggle-group {
            margin: 5px;
        }
    }
}

@media (max-width: 1280px) {
    #progress-view,
    #yazdir-tab {
        display: none;
    }
    #content.servis-content {
        padding: 68px 0 50px 0 !important;
    }
    #content.document-content {
        padding: 0 0 50px 0 !important;
    }
    .yatis-content {
        align-items: initial;
        .wizard,
        .p-not {
            flex: 1 1 100%;
        }
    }
    .y-hazirtdv {
        flex-direction: column;
        table {
            width: 100%;
            flex: 1 1 100%;
        }
    }
    .y-sarilik {
        flex-direction: column !important;
        grid-template-columns: repeat(auto-fit, minmax(100%, 1fr)) !important;
    }
    .y-grafik {
        flex-direction: column;
        .grafik-tabs {
            flex-direction: row !important;
            align-items: center !important;
            border-right: 0 !important;
            border-bottom: 1px solid $gray-200;
        }
        .grafik-tabs li {
            width: 80px !important;
        }
        .tab-content img {
            padding: 10px !important;
        }
    }
}

// Dökümanlar

.document-content {
    padding: 0 280px 0 0 !important;
    display: flex;
    flex-wrap: wrap;
}

.docs {
    table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 5px;
        font-size: 12px;
        tr.selected {
            td {
                background-color: lighten($sidebarLight, 10);
                color: white;
                svg {
                    color: white;
                }
            }
            &:hover td {
                background-color: $sidebar;
            }
        }

        tr td {
            svg {
                color: $blue;
                margin: 0 2px;
            }
            cursor: pointer;
        }
        tr:hover td {
            background-color: transparentize($primary, 0.8);
        }
        tr.empty th {
            height: 84px;
            background-color: lighten($orange, 15) !important;
        }
        th,
        td {
            text-align: left;
            padding: 8px;
            color: #000;
        }
        th {
            background-color: $orange;
            font-size: 12px;
        }
        tr:nth-child(odd) {
            background-color: lighten($orange, 15);
        }
        tr:nth-child(even) {
            background: lighten($orange, 20);
        }
    }
}

.doc-detail {
    display: block;
    flex: 1 1 auto;
    border-bottom: 1px solid $gray-300;
    .topbar {
        background-color: $gray-100;
        span.head {
            display: block;
            padding: 10px;
            font-size: 22px;
        }
        div.detail {
            display: block;
            padding: 5px;
            border-bottom: 1px solid $gray-200;
        }
        span.detail {
            color: $text;
            padding: 5px;
            display: inline-block;
        }
        a {
            float: right;
        }
    }
}
.doc-page {
    padding: 20px 0;
    background-color: white;
    .doc-page-detail {
        margin: 0 auto;
        width: 95%;
        color: #000;
        ol,
        ul {
            margin-top: 1em;
            margin-bottom: 1em;
            margin-left: 0;
            margin-right: 0;
            padding-left: 20px;
            line-height: 20px;
        }
        ul {
            list-style-type: initial;
        }
        .text-tiny {
            font-size: 0.7em;
        }
        .text-small {
            font-size: 0.85em;
        }
        .text-big {
            font-size: 1.4em;
        }
        .text-huge {
            font-size: 1.8em;
        }
        .media {
            clear: both;
            margin: 1em 0;
            display: block;
            min-width: 15em;
        }
        .image {
            display: table;
            clear: both;
            text-align: center;
            margin: 1em auto;
            img {
                display: block;
                margin: 0 auto;
                max-width: 100%;
                min-width: 50px;
            }
            > figcaption {
                display: table-caption;
                caption-side: bottom;
                word-break: break-word;
                color: hsl(0, 0%, 20%);
                background-color: hsl(0, 0%, 97%);
                padding: 0.6em;
                font-size: 0.75em;
                outline-offset: -1px;
            }
        }
        .image.image_resized {
            max-width: 100%;
            display: block;
            box-sizing: border-box;
            img {
                width: 100%;
            }
            > figcaption {
                display: block;
            }
        }
        .image-style-side,
        .image-style-align-left,
        .image-style-align-center,
        .image-style-align-right {
            max-width: 50%;
        }
        hr {
            margin: 15px 0;
            height: 4px;
            background: hsl(0, 0%, 87%);
            border: 0;
        }
        .image-style-align-left {
            float: left;
            margin-right: var(--ck-image-style-spacing);
        }

        .image-style-align-center {
            margin-left: auto;
            margin-right: auto;
        }

        .image-style-align-right {
            float: right;
            margin-left: var(--ck-image-style-spacing);
        }

        figure {
            margin: 0 auto;
        }

        table {
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
            height: 100%;
            border: 1px double hsl(0, 0%, 70%);
        }
        table td,
        table th {
            min-width: 2em;
            padding: 0.4em;
            border: 1px solid hsl(0, 0%, 75%);
        }
        table th {
            font-weight: bold;
            background: hsla(0, 0%, 0%, 5%);
        }

        code {
            background-color: hsla(0, 0%, 78%, 0.3);
            padding: 0.15em;
            border-radius: 2px;
        }
        blockquote {
            overflow: hidden;
            padding-right: 1.5em;
            padding-left: 1.5em;
            margin-left: 0;
            margin-right: 0;
            font-style: italic;
            border-left: solid 5px hsl(0, 0%, 80%);
        }
    }
}
</style>
